import { createContext, useState } from 'react';

import OrgUnitAthleteEntryInfoData from './OrgUnitAthleteEntryInfoData';

export const OrgUnitAthleteEntryInfoStateContext = createContext();

const OrgUnitAthleteEntryInfoContextProvider = ({ children }) => {
  const stateHook = useState(OrgUnitAthleteEntryInfoData.INITIAL_STATE);

  return (
    <OrgUnitAthleteEntryInfoStateContext.Provider value={stateHook}>
      {children}
    </OrgUnitAthleteEntryInfoStateContext.Provider>
  );
};

export default OrgUnitAthleteEntryInfoContextProvider;